import { Route, Routes } from "react-router-dom";
import Footer from "./components/Footer";
import Header from "./components/Header";
import AddReview from "./pages/AddReview/AddReview";
import Blogs from "./pages/Blogs/Blogs";
import Dashboard from "./pages/Dashboard/Dashboard";
import Home from "./pages/Home/Home";
import Login from "./pages/Login/Login";
import MyOrders from "./pages/MyOrders/MyOrders";
import MyProfile from "./pages/MyProfile/MyProfile";
import Portfolio from "./pages/Portfolio/Portfolio";
import Register from "./pages/Register/Register";
import NotFound from "./pages/NotFound/NotFound";
import "./App.scss";
import PrivateRoute from "./components/PrivateRoute";
import Purchase from "./pages/Purchase/Purchase";
import AddProduct from "./pages/AddProduct/AddProduct";
import Payment from "./pages/Payment/Payment";
import ManageOrders from "./pages/ManageOrders/ManageOrders";
import ManageUsers from "./pages/ManageUsers/ManageUsers";
import ManageProducts from "./pages/ManageProducts/ManageProducts";

function App() {
  return (
    <div className="App bg-yellow-50 overflow-hidden">
      <Header />

      <div className="max-w-[1536px] mx-auto">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          <Route path="/purchase">
            <Route
              path=":id"
              element={<PrivateRoute children={<Purchase />} />}
            />
          </Route>

          <Route path="/payment">
            <Route
              path=":id"
              element={<PrivateRoute children={<Payment />} />}
            />
          </Route>

          <Route
            path="/dashboard"
            element={<PrivateRoute children={<Dashboard />} />}
          >
            <Route path="" element={<MyProfile />} />

            <Route path="profile" element={<MyProfile />} />

            <Route path="my-orders" element={<MyOrders />} />

            <Route path="add-review" element={<AddReview />} />

            <Route path="add-product" element={<AddProduct />} />

            <Route path="manage-users" element={<ManageUsers />} />

            <Route path="manage-orders" element={<ManageOrders />} />

            <Route path="manage-products" element={<ManageProducts />} />
          </Route>

          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>

      <Footer />
    </div>
  );
}

export default App;
